// test1354
(1354 && 0);
